import type { PricingStrategyProfileResponse } from '@/shared/api';
import { buildDemandSections } from './profileComparisonDemandSections';
import type { ProfileComparisonSection } from './profileComparisonModel';
import { buildPolicySection } from './profileComparisonPolicySection';
import { buildTimingSections } from './profileComparisonTimingSections';

export type { ProfileComparisonSection } from './profileComparisonModel';

export function buildProfileComparisonSections(
  profiles: PricingStrategyProfileResponse[],
): ProfileComparisonSection[] {
  return [
    ...buildDemandSections(profiles),
    ...buildTimingSections(profiles),
    buildPolicySection(profiles),
  ];
}
